var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: {
          padding: "10px 10px 10px 20px",
          "line-height": "26px",
          color: "#F59A23",
          background: "#D9EDF7",
        },
      },
      [
        _vm._v(
          "注意：1.阿里云的云端存储服务需要的配置参数，注意先去阿里云开通相关服务！ 2.打包前需配置完成否则无法打包!"
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "mt20",
        staticStyle: {
          background: "#fff",
          padding: "30px",
          "border-radius": "20px",
        },
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("el-divider"),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "ruleForm",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.ruleForm,
                  rules: _vm.rules,
                  "label-width": "150px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "AccessKey ID", prop: "accessKey" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.ruleForm.accessKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "accessKey", $$v)
                        },
                        expression: "ruleForm.accessKey",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "AccessKey Secret", prop: "secretKey" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.ruleForm.secretKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "secretKey", $$v)
                        },
                        expression: "ruleForm.secretKey",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "Bucket名称", prop: "bucketName" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.ruleForm.bucketName,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "bucketName", $$v)
                        },
                        expression: "ruleForm.bucketName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "EndPoint", prop: "endpoint" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.ruleForm.endpoint,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "endpoint", $$v)
                        },
                        expression: "ruleForm.endpoint",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.submitForm("ruleForm")
                          },
                        },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "mt20",
        staticStyle: {
          background: "#fff",
          padding: "30px",
          "border-radius": "20px",
        },
      },
      [
        _vm._m(1),
        _vm._v(" "),
        _c("el-divider"),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "ruleForm1",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.ruleForm,
                  rules: _vm.rules1,
                  "label-width": "150px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "AccessKey ID", prop: "accessKey" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.ruleForm1.accessKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm1, "accessKey", $$v)
                        },
                        expression: "ruleForm1.accessKey",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "AccessKey Secret", prop: "secretKey" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.ruleForm1.secretKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm1, "secretKey", $$v)
                        },
                        expression: "ruleForm1.secretKey",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "Bucket名称", prop: "bucketName" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.ruleForm1.bucketName,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm1, "bucketName", $$v)
                        },
                        expression: "ruleForm1.bucketName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "EndPoint", prop: "endpoint" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.ruleForm1.endpoint,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm1, "endpoint", $$v)
                        },
                        expression: "ruleForm1.endpoint",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.submitForm1("ruleForm1")
                          },
                        },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex" }, [
      _c(
        "div",
        { staticStyle: { "font-weight": "600", "font-size": "26px" } },
        [_vm._v("私有读写权限参数配置")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "fc ml20", staticStyle: { color: "red" } }, [
        _vm._v("以下参数设定后请勿随意修改，可能导致系统功能无法正常使用!"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex" }, [
      _c(
        "div",
        { staticStyle: { "font-weight": "600", "font-size": "26px" } },
        [_vm._v("公共读写权限参数配置")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "fc ml20", staticStyle: { color: "red" } }, [
        _vm._v("以下参数设定后请勿随意修改，可能导致系统功能无法正常使用!"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }